// Dealer Vehicle Registration Form (CVRF) status codes.
// Previously this enum was defined separately in index.jsx and
// hook/useVehicleRegistrationFormData.js (identical values, two copies that could
// silently drift out of sync). Kept in one place now.
export const CVRFStatus = {
    Draft: 5,
    SentForApproval: 20,
    Return: 25,
    Approved: 30
};
